import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { SiteResponse } from "~types/site.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
};

export const useFetchSites = ({ customParams }: Props) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["sites", sport, organizationId, customParams],
    queryFn: () =>
      request<SiteResponse>(`${sport}/o/${organizationId}/sites?${params.toString()}`).then((response) => {
        return transformListResponse(response);
      }),
  });
};
